import { QUERY_KEYS } from "@/libraries/constant";
import { verificationService } from "@/services";
import type { QueryClient } from "@tanstack/react-query";

const send = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_VERIFY_PHONE_NUMBER], {
		mutationFn: verificationService.send.bind(verificationService),
	});
};

const resend = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults(
		[QUERY_KEYS.MUTATE_VERIFY_RESEND_PHONE_NUMBER],
		{
			mutationFn: verificationService.resend.bind(verificationService),
		},
	);
};

const verify = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_VERIFY_PHONE_CODE], {
		mutationFn: verificationService.verify.bind(verificationService),
	});
};

export const verifyMutations = (queryClient: QueryClient) => {
	send(queryClient);
	resend(queryClient);
	verify(queryClient);
};
